import React from "react";
import { motion } from "framer-motion";
import mozfin from "../assets/imgTwo/bank.svg";
import octopus from "../assets/imgTwo/home-pos.png";
import sare from "../assets/imgTwo/home-sare.png";
import pensol from "../assets/imgTwo/home-pensol.png";
import money from "../assets/imgTwo/naira.svg";
import support from "../assets/imgTwo/call-center.svg";
import data from "../assets/imgTwo/data.svg";
import secure from "../assets/imgTwo/flash.svg";
import simplify from "../assets/imgTwo/Aftersell.gif";
import financial from "../assets/imgTwo/b.svg";
import unlock from "../assets/imgTwo/d.svg";
import perform from "../assets/imgTwo/c.svg";
import excellence from "../assets/imgTwo/excellence.svg";
import posWoman from "../assets/imgTwo/Desktop10.png";
import guyPhone from "../assets/imgTwo/Desktop11.png";
import girl from "../assets/img/lady-red.png";
import guyAtm from "../assets/imgTwo/Desktop9.png";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import "../App.css";
import Arrow from "../assets/imgTwo/arrow.svg";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

const slideInFromRight = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const slideInFromLeft = {
  hidden: { opacity: 0, x: -100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

const slideInFromBottom = {
  hidden: { opacity: 0, y: 100 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};


export const HeroSection = () => {
  const [emblaRef] = useEmblaCarousel({ loop: false }, [Autoplay()]);

  return (
    <section id="about" className="bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein">
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[3.5rem] font-bold mb-4 leading-normal">
            Empowering Businesses <br />with{" "}
            <span className="text-[#07775D]">
              Seamless Financial<br />
              Solutions.
            </span>
          </h2>
          <p className="text-gray-800 text-lg">
            From payments to disbursements, digital banking, and agency banking
            solutions, Uniswitch provides the tools you need to simplify financial
            operations and scale your business.
          </p>
          <Link
            to="/products"
          >
            <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-6 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">
              Learn more
              <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
                <img src={Arrow} alt="enter" />
              </span>
            </button>
          </Link>
        </div>
        <motion.div
          className="w-full md:w-[35em] p-2 flex md:justify-end"
          variants={slideInFromRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <div className="embla" ref={emblaRef}>
            <div className="embla__container">
              <div className="embla__slide">
                <img src={mozfin} alt="mozfin" className="rounded-lg" />
              </div>
              <div className="embla__slide">
                <img
                  src={octopus}
                  alt="octopus"
                  className="rounded-lg"
                />
              </div>
              <div className="embla__slide">
                <img
                  src={sare}
                  alt="sare"
                  className="rounded-lg"
                />
              </div>
              <div className="embla__slide">
                <img
                  src={pensol}
                  alt="pensol"
                  className="rounded-lg"
                />
              </div>
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

const AboutSection = () => (
  <section
    id="home"
    className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col justify-between md:flex-row items-center">

      <motion.div
        className="w-full md:w-1/2 p-4"
        variants={slideInFromLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={simplify} alt="simplify payments" className="rounded-lg" />
      </motion.div>
      <div className="w-full md:w-1/2 p-2">
        <h2 className="text-2xl md:text-4xl font-bold mb-4">
          Simplify Payments for Customers and Businesses
        </h2>
        <p className="text-gray-800 text-lg">
          Accept payments anywhere, anytime. Uniswitch's payment gateway enables
          businesstes to accept payments through various channels, ensuring
          seamless transactions for both customers and businesses.
        </p>
        <p className="font-bold my-4">For Business and Customer</p>
        <ul className="grid grid-cols-2 gap-x-4 gap-y-4 text-gray-800 list-none">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Payment Collection
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Trusted Reliability
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Transaction Insights
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Seamless Experience
          </li>
        </ul>
        <a href="https://sarepay.com/" className="text-inherit no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-6 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">

            Learn more
            <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img src={Arrow} alt="enter" />
            </span>


          </button>
        </a>
      </div>
    </div>

  </section>
);

const PortfolioSection = () => (
  <section
    id="portfolio"
    className="container mx-auto md:px-[5em] flex flex-col-reverse md:flex-row items-center justify-apart py-16 animate-slidein"
  >
    <div className="w-full md:w-1/2 p-4">
      <h2 className="text-2xl md:text-4xl font-bold mb-4">
        Bring Financial Services Closer
      </h2>
      <p className="text-gray-800 text-lg">
        Expand financial access with Agency Banking. Uniswitch’s Agency Banking
        Solution empowers businesses to manage a network of agents delivering
        essential financial services to underserved communities.
      </p>
      <p className="font-semibold my-4">What You Can Do</p>
      <ul className="list-none grid grid-cols-2 gap-x-4 gap-y-4 text-gray-800">
        <li>
          <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
          Agent Management
        </li>
        <li>
          <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
          Business Expansion
        </li>
        <li>
          <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
          Service Enablement
        </li>
        <li>
          <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
          Transaction Monitoring
        </li>
      </ul>
      <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-6 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">
        Learn more
        <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
          <img src={Arrow} alt="enter" />
        </span>
      </button>
    </div>
    <motion.div
      className="w-full md:w-1/2 p-2 flex md:justify-end"
      variants={slideInFromRight}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <img src={financial} alt="financial services" className="rounded-lg" />
    </motion.div>
  </section>
);



const ServicesSection = () => (
  <section
    id="services"
    className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col justify-between md:flex-row items-center">
      <motion.div
        className="w-full md:w-1/2 p-2"
        variants={slideInFromLeft}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={perform} alt="perform disbursements" className="rounded-lg" />
      </motion.div>
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-4xl font-bold mb-4">
          Perform Disbursements with Ease
        </h2>
        <p className="text-gray-800 text-lg">
          Streamline payouts for payroll, vendors, and refunds. Uniswitch’s
          Disbursement Solution helps businesses manage payouts efficiently,
          saving time and reducing errors.
        </p>
        <p className="font-semibold my-4">What You Can Do</p>
        <ul className="list-none grid grid-cols-2 gap-x-4 gap-y-4 text-gray-800">
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Bulk Disbursement
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Secure Transfers
          </li>
          <li>
            <span className="h-2 w-2 bg-black rounded-full inline-block mr-2"></span>
            Disbursement Tracking
          </li>
        </ul>
        <a href="https://sarepay.com/" className="text-inherit no-underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="bg-[#07775D] flex items-center justify-center text-white my-6 rounded-full px-6 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">
            Learn more
            <span className="ml-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img src={Arrow} alt="enter" />
            </span>
          </button>
        </a>
      </div>
    </div>
  </section>
);

function BusinessCarousel() {
  // const imageUrls = [posWoman, guyPhone, guyAtm, girl];

  const [emblaRef] = useEmblaCarousel(
    { loop: true, align: "start" },
    [Autoplay({ delay: 2000 })]
  );
  return (
    <section id="portfolio" className="bg-[#001100] py-16 animate-slidein">
      <div className="mx-auto py-16">
        <h2 className="text-5xl text-white text-center px-12 font-bold mb-4 md:mx-[2.5em] py-4 leading-relaxed">
          Uniswitch empowers your business to<br></br> simplify finances and scale<br></br>
          effortlessly!
        </h2>

        <div className="flex-col md:flex-row md:flex items-center justify-center md:space-x-6 mx-2 mb-12">
          <div className="bg-[#596459] border border-white flex items-center justify-center text-white my-6 rounded-lg px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            <span className="mr-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img className="text-white" src={money} alt="money-icon" />
            </span>
            Effortless disbursement
          </div>
          <div className="bg-[#596459] border border-white  flex items-center justify-center text-white my-6 rounded-lg px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            <span className="mr-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img className="text-white" src={support} alt="money-icon" />
            </span>
            24/7 Customer support
          </div>
          <div className="bg-[#596459] border border-white  flex items-center justify-center text-white my-6 rounded-lg px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            <span className="mr-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img className="text-white" src={data} alt="money-icon" />
            </span>
            Data Driven Financial Insights
          </div>
          <div className="bg-[#596459] border border-white  flex items-center justify-center text-white my-6 rounded-lg px-12 py-3 font-semibold transition-all duration-300 hover:bg-green-800 group">
            <span className="mr-2 transform transition-transform duration-300 group-hover:translate-x-1">
              <img className="text-white" src={secure} alt="money-icon" />
            </span>
            Fast and Secure transfers
          </div>
        </div>

        <div>
          <div className="embla" ref={emblaRef}>
            <div className="f_embla__container">
              <div className="f_embla__slide">
                <img src={posWoman} alt="Hero" className="rounded-lg" />
              </div>
              <div className="f_embla__slide">
                <img src={guyPhone} alt="financial services" className="rounded-lg" />
              </div>
              <div className="f_embla__slide">
                <img src={guyAtm} alt="financial services" className="rounded-lg" />
              </div>
              <div className="f_embla__slide">
                <img src={girl} alt="financial services" className="rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export { BusinessCarousel };

const UnlockSection = () => (
  <section
    id="portfolio"
    className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
      <div className="w-full md:w-[130em] h-[32em]  p-8 py-10 border border-gray-400 rounded-3xl">
        <h2 className="text-2xl md:text-4xl font-bold mb-4">
          Unlock new possibilities with seamless<br></br> payment solutions.
        </h2>
        <p className="text-gray-800 text-lg">
          Simplify transactions, accelerate growth, and empower your business with<br></br>
          innovative financial tools.
        </p>
        <div>
          <img
            src={excellence}
            alt="financial excellence"
            className="rounded-lg"
          />
        </div>
      </div>

      <motion.div
        className="w-full md:w-[] h-[32em]  m-0 flex md:justify-end"
        variants={slideInFromBottom}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={unlock} alt="unlock possibilities" className="rounded-lg" />
      </motion.div>

    </div>
  </section>
);

// const ContactSection = () => (
//   <section
//     id="contact"
//     className="bg-[#001100] text-white py-8 flex justify-center items-center text-center"
//   >
//     <div className="w-full p-4 space-y-8">
//       <h2 className="text-4xl font-bold mb-4">
//         Have questions or ready to start?
//       </h2>
//       <p className="text-lg md:mx-[30em]">
//         Contact us today and unlock seamless financial solutions for your
//         business.
//       </p>
//       <button className="bg-[#07775D] flex items-center justify-center mx-auto text-white my-6 rounded-full px-8 py-2 font-semibold transition-all duration-300 hover:bg-green-800 group">
//         Contact us
//       </button>
//       <div className="pt-4 w-2/3 mx-auto">
//         <hr></hr>
//       </div>
//     </div>
//   </section>
// );



export const Home = () => (
  <div className="font-san mx-auto bg-[#F7F7F7] pt-6">
    <Navbar />
    <HeroSection />
    <AboutSection />
    <PortfolioSection />
    <ServicesSection />
    <BusinessCarousel />
    <UnlockSection />
    <Footer />
  </div>
);

export default Home;
